export default {
    cpf(v: any) {
        v = this.semPontoTracoBarra(v);
        if (v.toString().length === 11) {
            v = v.replace(/(\d{3})(\d)/, '$1.$2');
            v = v.replace(/(\d{3})(\d)/, '$1.$2');
            v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
            return v;
        }
        return v;
    },
    cnpj(v: any) {
        v = this.semPontoTracoBarra(v);
        if (v.toString().length === 14) {
            v = v.toString().replace(/(\d{2})(\d)/, '$1.$2');
            v = v.toString().replace(/(\d{3})(\d)/, '$1.$2');
            v = v.toString().replace(/(\d{3})(\d)/, '$1/$2');
            v = v.toString().replace(/(\d{4})(\d{1,2})$/, '$1-$2');
            return v;
        }
        return v;
    },
    celular(v: any) {
        v = v.replace(/\D/g, '');
        v = v.replace(/(\d{2})(\d)/, '($1) $2');
        v = v.replace(/(\d{5})(\d)/, '$1-$2');
        return v;
    },
    cpfCnpj(v: any) {
        const text = this.semPontoTracoBarra(v);
        if (text.toString().length === 11) {
            return this.cpf(text);
        } else if (text.toString().length === 14) {
            return this.cnpj(text);
        }
        return v;
    },
    semPontoTracoBarra(v: any) {
        return v.toString().replace(/\.|\-|\//g, '');
    },
};
